
























































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import ICalendar from '@/components/icons/ICalendar.vue'
import {namespace} from "vuex-class";

const locale = namespace('locale')

@Component({
  name: "DatePicker",
  components: {
    'i-calendar': ICalendar,
  }
})
export default class DatePicker extends Vue {

  @locale.Getter('getLocale') protected locale: any

  @Prop({type: Boolean, default: false}) menuDatePicker !:any

  @Prop({
    type: Array,
    default() {
      return "";
    },
  })
  value!: any;
  @Prop({
    type: String,
    default() {
      return "";
    },
  })
  label!: string;
  menu: boolean = false
  dates: any = this.value
  date: string = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
  currentDates:any = []

  get dateRangeText() {
    let result = this.validDates(this.dates)
    if (result.length > 1) {
      let first = result[0].split('-')
      let second = result[1].split('-')
      return first[2] + '.' + first[1] + '.' + first[0] + ' - ' + second[2] + '.' + second[1] + '.' + second[0]
    } else if (result.length === 1) {
      let first = result[0].split('-')
      return first[2] + '.' + first[1] + '.' + first[0]
    }
  }

  @Watch('value')
  setItem(newVal: any) {
    this.dates = newVal
  }

  validDates(arr:any[]){
    if(arr.length >1){
      const  first = arr[0]
      const second = arr[1]

      if(new Date(second)< new Date(first)){
        return [second, first]
      }

    }
    return arr
  }

  @Watch('dates')
  handleInput() {
    const result = this.validDates(this.dates)
    this.$emit("input",result);
  }

  cancel() {
    this.menu = false
    this.dates = [...this.currentDates]
    this.$emit("changeDatePicker", false);
  }

  openModal() {
    this.currentDates = [...this.dates]
    this.$emit("changeDatePicker", true);
  }

  selectDates() {
    this.menu = false
    this.$emit("changeDatePicker", false);
  }

  deleteDate() {
    this.dates = []
  }
}
